module.exports = __webpack_public_path__ + "static/a2-inside-321467e2604dcea681323bbababf57d7.png";